/**
 * AdminPanel — central mod console, faithful to legacy
 * DefineSprite_363_adminWindow:
 *
 *   ┌── Admin Panel ───────────────────────────────[×]┐
 *   │ Banning/Muting a User       Username [_____]    │
 *   │  1. Choose or enter username                    │
 *   │  2. Choose a time value     Time     [_____]    │
 *   │  3. Press ban or mute       [BAN USER] [MUTE]   │
 *   │                                                  │
 *   │ Closing Chat                                     │
 *   │  1. Choose a time           Time     [_____]    │
 *   │  2. Press Close Chat        [CLOSE CHAT]        │
 *   │                                                  │
 *   │ Opening Chat                                     │
 *   │  Press Open Chat button                          │
 *   │                                                  │
 *   │  [CLEAR CHAT] [CLOSE CHAT] [OPEN CHAT]          │
 *   └─────────────────────────────────────────────────┘
 */
import { useState } from 'react';
import { Modal } from './Modal.js';

interface Props {
    room: string;
    onClose: () => void;
    onSend: (frame: object) => void;
    onClearChat: () => void;
}

export function AdminPanel({ room, onClose, onSend, onClearChat }: Props) {
    const [user, setUser]   = useState('');
    const [bmins, setBmins] = useState(60);
    const [cmins, setCmins] = useState(5);

    return (
        <Modal title="Admin Panel" onClose={onClose} className="pc-modal-admin">
            <fieldset className="ap-section">
                <legend>Banning / Muting a User</legend>
                <ol className="ap-steps">
                    <li>Choose or enter a username.</li>
                    <li>Choose a time value (minutes).</li>
                    <li>Press <b>Ban</b> or <b>Mute</b>.</li>
                </ol>
                <div className="ap-row">
                    <label>Username</label>
                    <input type="text" value={user} maxLength={64}
                           onChange={e => setUser(e.target.value)} />
                </div>
                <div className="ap-row">
                    <label>Time</label>
                    <input type="number" min={0} max={60*24*30} value={bmins}
                           onChange={e => setBmins(Number(e.target.value || 0))} />
                    <span className="ap-unit">min</span>
                    <button className="pw-btn pw-btn-mod"
                            disabled={!user.trim()}
                            onClick={() => onSend({ cmd: 'mute_user', room, user: user.trim(), minutes: bmins })}>
                        MUTE
                    </button>
                    <button className="pw-btn pw-btn-mod pw-btn-danger"
                            disabled={!user.trim()}
                            onClick={() => onSend({ cmd: 'ban_user', room, user: user.trim(), minutes: bmins })}>
                        BAN
                    </button>
                </div>
            </fieldset>

            <fieldset className="ap-section">
                <legend>Closing / Opening Chat</legend>
                <div className="ap-row">
                    <label>Time</label>
                    <input type="number" min={0} max={60*24*30} value={cmins}
                           onChange={e => setCmins(Number(e.target.value || 0))} />
                    <span className="ap-unit">min</span>
                    <button className="pw-btn pw-btn-mod"
                            onClick={() => onSend({ cmd: 'close_chat', room, minutes: cmins })}>
                        CLOSE CHAT
                    </button>
                    <button className="pw-btn pw-btn-mod"
                            onClick={() => onSend({ cmd: 'open_chat', room })}>
                        OPEN CHAT
                    </button>
                </div>
            </fieldset>

            <div className="ap-foot">
                <button className="pw-btn"
                        onClick={() => { onClearChat(); onClose(); }}>
                    CLEAR CHAT
                </button>
            </div>
        </Modal>
    );
}
